<template>
    <div class="main">
        <c-panel>
            <form-protocolo :paramId="$route.params.id" v-on:onSubmitProtocolo="onSubmitProtocolo"></form-protocolo>
        </c-panel>
    </div>
</template>

<script>
import formProtocolo from './form'

export default {
    methods: {
        onSubmitProtocolo () {
            this.$router.push('/admin/protocolo')
        }
    },
    components: { formProtocolo }
}
</script>

